import { render } from "./BuyAccidentComponent.vue?vue&type=template&id=e9e484e4&ts=true"
import script from "./BuyAccidentComponent?vue&type=script&lang=ts"
export * from "./BuyAccidentComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__